//import { cols } from //'@components-common';
import _ from 'lodash';
import { cols } from './columns';
import { IColumnProps } from 'taltech-styleguide';

export const columnTypes = [
  'id',
  'number',
  'name',
  'firstName',
  'lastName',
  'description',
  'type',
  'createdDate',
  'modifiedDate',
  'startDate',
  'endDate',
  'valueDefault',
  'min',
  'max',
  'courseLogo',
  'lecturer',
  'email',
  'title',
  'submissions',
  'state',
  'class',
  'role',
  'initials',
  'stateTag',
  'custom'
] as const;

export type ColumnTypeSet = {[K in typeof columnTypes[number]]: K};
export const entityColumns = ['id', 'createdDate', 'modifiedDate'];

export const commonColumns = ['name', 'description', ...entityColumns];

export const columnElementsProvider = _.keyBy(columnTypes);

export const column_components: {[K in keyof ColumnTypeSet]:Partial<IColumnProps>} =
columnTypes.reduce((p,c)=>{
  return {...p, [c]:{...(cols)[c](), type: 'column', id: c }}
},{} as{ [K in typeof columnTypes[number]]:Partial<IColumnProps>});
